import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Spin,
  List,
  Avatar,
  Input,
  Image,
  Button,
  Modal,
  Dropdown,
  Menu,
  Popconfirm,
  Upload,
} from "antd";
import {
  CheckCircleOutlined,
  PlusOutlined,
  PlusCircleOutlined,
  DownloadOutlined,
  DeleteOutlined,
  UserOutlined,
  MoreOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { IoMdAttach } from 'react-icons/io';
import "./style.css";
import type { IHighlight } from "../DocumentVerification/react-pdf-highlighter";
import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation, useHistory } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { MentionsInput, Mention } from "react-mentions";
import { getDocumentComments, DocumentCommentsSelector, AddCommentsAsyn, clearAddResponseState, clearState, DeleteCommentsAsyn, getAtrateUsernameAsyn, clearAtRateUserNameState } from './DocumentCommentsSlice';
import { copyFileSync } from "fs";
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

const commentdata = [
  {
    name: 'Jim Doe',
    role: 'Clerk',
    highlight: 'Certificate of education',
    comment: 'Please check',
    image: null,
    document: null,
    date: '30/09/2021, 11:00 PM',
    replies: [
      {
        name: 'Nicole Kelly',
        role: 'Director',
        reply: 'tagged here',
        image: null,
        document: null,
        date: '30/09/2021, 11:00 PM',
      },
      {
        name: 'Nicole Kelly',
        role: 'Director',
        reply: 'Already tagged here',
        image: null,
        document: null,
        date: '30/09/2021, 11:00 PM',
      },
      {
        name: 'Nicole Kelly',
        role: 'Director',
        reply: 'check please',
        image: null,
        document: null,
        date: '30/09/2021, 11:00 PM',
      },
      {
        name: 'Nicole Kelly',
        role: 'Director',
        reply: 'Checked',
        image: null,
        document: null,
        date: '30/09/2021, 11:00 PM',
      }
    ]
  },
  {
    name: 'Nicole Kelly',
    role: 'Director',
    highlight: '',
    comment: 'Check below',
    image: null,
    document: null,
    date: '30/09/2021, 11:00 PM',
    replies: []
  },
  {
    name: 'Jim Doe',
    role: 'Clerk',
    highlight: '',
    comment: '',
    image: 'default-View-SubAdmin-Img.png',
    document: null,
    date: '30/09/2021, 11:00 PM',
    replies: []
  },
  {
    name: 'Jim Doe',
    role: 'Clerk',
    highlight: '',
    comment: 'Upload document',
    image: null,
    document: null,
    date: '30/09/2021, 11:00 PM',
    replies: [{
      name: 'Nicole Kelly',
      role: 'Director',
      reply: 'Ok',
      image: null,
      document: null,
      date: '30/09/2021, 11:00 PM',
    }]
  },
];

const data = [
  {
    deptTypeName: 'CCIS',
    info: [],
  },
  {
    deptTypeName: 'CCIS',
    info: [],
  },
];

interface Props {

}


export default function DocumentComments({ }: Props) {

  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();
  const [isLoading, setLoading] = React.useState(false);
  const [replyText, setReplyText] = React.useState({});
  const [commentText, setCommentText] = React.useState('');
  const [attachFile, setattachFile] = React.useState([]);
  const [attachImage, setattachImage] = React.useState([]);
  const [AtRateUsers, setAtRateUsers] = React.useState<any>([]);

  const { isFetching, isCommentDataSuccess, isAddResponse, atRateUserData, isAtrateSuccess, isError, errorMessage, commentsData, imagePath, profileImagePath } = useSelector(
    DocumentCommentsSelector
  );

  const [allcommentData, setAllcommentData] = useState<any>(null);
  const [isCommentModalVisible, setIsCommentModalVisible] = useState(false);

  const [TypeInputData, setTypeInputData] = useState("");
  const [MentionData, setMentionData] = React.useState<any>([]);
  const [sendInputData, setsendInputData] = React.useState<any>("");


  const [RplyTypeInputData, setRplyTypeInputData] = React.useState("");
  const [RplyMentionData, setRplyMentionData] = React.useState<any>([]);
  const [sendRplyInputData, setsendRplyInputData] = React.useState<any>("");

  useEffect(() => {

    dispatch(clearState());
    // setLoading(true);
    // console.log(locationProp.state.documentInfo.document_UUID)
    dispatch(getDocumentComments(location.state.documentInfo.document_UUID));
    dispatch(getAtrateUsernameAsyn(location.state.documentInfo.document_UUID))

  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);
      toast.error(errorMessage);
    }
    if (isCommentDataSuccess) {
      setLoading(false);
      setAllcommentData(commentsData);
      //  setminutesStageData(stageData);

    }

    if (isAddResponse) {
      setLoading(false);
      setReplyText('');
      setCommentText('');
      setTypeInputData('');
      setRplyTypeInputData('');
      setIsCommentModalVisible(false);
      dispatch(clearAddResponseState());
      dispatch(getDocumentComments(location.state.documentInfo.document_UUID));

    }

    if (isAtrateSuccess) {
      setLoading(false);
      let data: any[] = [];
      if (atRateUserData) {

        for (let i: number = 0; i < atRateUserData.length; i++) {
          data.push({ id: i, display: atRateUserData[i].detailedUser.fullName })
        }

      }
      setAtRateUsers(data);
      // dispatch(clearAtRateUserNameState());
    }

  }, [isError, isCommentDataSuccess, isAddResponse, atRateUserData, isAtrateSuccess, setLoading, setReplyText, setIsCommentModalVisible, setCommentText, commentsData, imagePath, clearAddResponseState, getDocumentComments]);


  const showModal = () => {
    setIsCommentModalVisible(true);
  };

  const handleOk = () => {
    setIsCommentModalVisible(false);
  };

  const handleCancel = () => {
    setIsCommentModalVisible(false);
  };

  const addComment = (e: any) => {
    // console.log("TypeInputData= ", sendInputData);
    // console.log("MentionData= ", MentionData);

    if (sendInputData) {

      const formData: any = new FormData();

      formData.append("docId", location.state.documentInfo.document_UUID);
      formData.append("commentText", sendInputData);
      formData.append("isHighLight", false);
      formData.append("commentFile", attachFile.length != 0 ? attachFile : attachImage.length != 0 ? attachImage : null);
      formData.append("tagUsers", JSON.stringify(MentionData));

      // console.log("attachFile " + attachFile)
      // console.log("attachImage " + JSON.stringify(attachImage))
      // console.log("formdata = " + JSON.stringify(formData))
      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ', ' + pair[1]);
      // }
      setIsCommentModalVisible(false);
      setLoading(true);
      dispatch(AddCommentsAsyn(formData));
    }
  }

  const addCommentReply = (e: any, uuid: any) => {
    // console.log("sendRplyInputData = ", sendRplyInputData);
    // console.log("RplyMentionData= ", RplyMentionData);

    if (sendRplyInputData) {
      // const formData = {
      //   docId: location.state.documentInfo.document_UUID,
      //   commentText: e.target.value,
      //   isHighLight: false,
      //   commentId: uuid
      // }
      const formData: any = new FormData();

      formData.append("docId", location.state.documentInfo.document_UUID);
      formData.append("commentText", sendRplyInputData);
      formData.append("isHighLight", false);
      formData.append("commentId", uuid);
      formData.append("commentFile", attachFile.length != 0 ? attachFile : attachImage.length != 0 ? attachImage : null);
      formData.append("tagUsers", JSON.stringify(RplyMentionData));

      setLoading(true);
      dispatch(AddCommentsAsyn(formData));
    }
  }


  const completedmenu = (commentType, row) => (
    <Menu>
      <Menu.Item key="1">
        <Popconfirm
          title="Do you want to delete this comment?"
          onConfirm={(e) => DelCompletedconfirm(e, commentType, row)}
          // onCancel={cancel}
          okText="Yes"
          cancelText="No"
          icon={<DeleteOutlined style={{ color: 'red' }} />}
        >
          <DeleteOutlined style={{ color: 'red' }} /> &nbsp; <span style={{ color: 'red' }}>Delete</span>
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

  const DelCompletedconfirm = (e, commentType, row) => {
    // reply , comment
    e.preventDefault();
    // console.log(e + " " + row.uuid);
    const data: any = {
      "id": row.uuid,
      "type": commentType,
    }
    // console.log("data => ", data);
    dispatch(DeleteCommentsAsyn(data));
    setTimeout(() => {
      dispatch(getDocumentComments(location.state.documentInfo.document_UUID));
    }, 400);

  }


  const addAttachments = (info) => {
    // console.log(info)
    setattachFile([]);
    setattachImage([]);

    if (info.file.type === 'application/pdf') {
      // console.log("pdf")
      setattachFile(info.file.originFileObj);
    }
    else if (info.file.type === 'image/jpeg' || info.file.type === 'image/png') {
      setattachImage(info.file.originFileObj);
      // console.log("imgUrl", info.file.originFileObj)

    }

  }



  const handleAtRateCommentChange = (e, newValue, newPlainTextValue, mentions) => {
    setTypeInputData(e.target.value);

    let senUserName: any[] = [];

    if (mentions.length > 0) {

      for (let i: number = 0; i < mentions.length; i++) {
        senUserName.push(mentions[i].display);
      }
    }
    setMentionData(senUserName);


    let a = e.target.value;
    setsendInputData(a);

    // let a = location.state.documentInfo.document_UUID + "&search=" + e.target.value;
    // dispatch(getAtrateUsernameAsyn(a))

  }


  const handleRplyAtRateCommentChange = (e: any, newValue, newPlainTextValue, mentions) => {
    setRplyTypeInputData(e.target.value);

    let senUserName: any[] = [];

    if (mentions.length > 0) {

      for (let i: number = 0; i < mentions.length; i++) {
        senUserName.push(mentions[i].display);
      }
    }
    // console.log("data =>" + JSON.stringify(senUserName));
    setRplyMentionData(senUserName);

    let a = e.target.value;
    setsendRplyInputData(a);

  }

  // console.log('allcommentData')
  // console.log(allcommentData)
  // console.log(commentsData)

  // console.log("AtRateUsers =", AtRateUsers)

  //console.log(commentsData.slice().sort((a:any, b:any) => b.uuid - a.uuid))
  let allcommentsData: any = allcommentData ? allcommentData.slice().reverse() : [];
  return (
    <>
      <Spin indicator={antIcon} style={{ alignItems: 'center', justifyContent: 'center', justifyItems: 'center', textAlign: 'center', width: '100%', maxHeight: '100%', position: 'fixed', zIndex: 1111, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={isLoading} />
      <Row>
        <Col span={24} style={{ textAlign: 'right', paddingBottom: 10, paddingRight: 20 }}>
          <Button onClick={showModal} style={{ borderColor: "#C1C1C1" }} type="primary" icon={<PlusOutlined />} ghost><span style={{ color: '#000' }}>Add Comment</span></Button>

          <Modal title="Add Comment" visible={isCommentModalVisible}
            okButtonProps={{
              style: {
                display: "none",
              },
            }} onCancel={handleCancel}>

            <MentionsInput
            className={'uper-comment-input'}
              placeholder="Add comment"
              // markup="@[__display__](__id__)"
              value={TypeInputData}
              onChange={handleAtRateCommentChange}
              singleLine="true"
            >
              <Mention appendSpaceOnAdd="true" trigger="@" data={AtRateUsers} />
            </MentionsInput>
            <Upload showUploadList={false} accept=".jpg,.png,.jpeg,.pdf" onChange={addAttachments}>
              <IoMdAttach style={{
                position: 'relative',
                bottom: '46px',
                left: '396px',
                fontSize: 21, marginTop: 2, cursor: 'pointer', color: 'rgba(0,0,0,.45)'
              }} /></Upload>
            <img src="./flaticons/send.png"
              onClick={(e) => addComment(e)}
              style={{
                position: 'relative',
                bottom: '52px',
                left: '399px', width: '21px', height: '21px', cursor: 'pointer'
              }} />

            {/* <Input
              className={'replyinputclass'}
              style={{ width: '90%', background: '#F2F2F2', marginTop: 10, marginBottom: 10, marginLeft: 10, marginRight: 10, border: '1px solid #dfe0eb', borderTopColor: '#dfe0eb', borderRadius: 32 }}
              placeholder="Add comment"
              onChange={(e) => setCommentText(e.target.value)}
              onPressEnter={(e) => addComment(e)}
              value={commentText}
              suffix={
                <Upload showUploadList={false} accept=".jpg,.png,.jpeg,.pdf" onChange={addAttachments}>
                  <IoMdAttach style={{ fontSize: 20, marginTop: 2, cursor: 'pointer', color: 'rgba(0,0,0,.45)' }} /></Upload>
              }
            /> */}
          </Modal>
        </Col>
      </Row>

      <List
        style={{ width: '100%', height: '68vh', paddingBottom: 20, paddingLeft: 5, paddingRight: 5, overflow: 'auto' }}
        itemLayout="horizontal"
        dataSource={allcommentsData}
        locale={{ emptyText: <p>No comments</p> }}
        renderItem={(item: any) => (
          <>
            <div style={{ marginBottom: item.commentReply && item.commentReply.length > 0 ? 0 : 0, border: '1px solid #dfe0eb', borderBottom: 0, padding: '5px 10px 0px 10px' }}>
              <List.Item>
                <List.Item.Meta
                  style={{ textAlign: 'left' }}
                  //avatar={<Avatar className={'avtar-img'} src="./images/doc-user-image.png" />}
                  avatar={item.detailedUserComment.profilePic ? <Avatar className={'avtar-img'} src={profileImagePath + item.detailedUserComment.profilePic} /> : <Avatar className={'avtar-img'} icon={<UserOutlined />} />}
                  title={<Row>
                    <Col span={20} style={{ textAlign: 'left' }}>
                      <span style={{ fontSize: 18, fontWeight: 500 }}>{item.detailedUserComment.fullName}</span>
                      <br />
                      <span style={{ color: '#9B9B9B' }}>{item.senderUserType}</span>
                    </Col>
                    <Col span={4} style={{ textAlign: 'right' }}>
                      <Dropdown
                        overlay={() => completedmenu("comment", item)}
                        trigger={["click"]}
                        placement="bottomRight"
                        arrow
                      >
                        <a
                          style={{ color: "#c5c7cd", fontSize: 25 }}
                          onClick={(e) => e.preventDefault()}
                        >
                          <span style={{ fontSize: 16, fontWeight: 500 }}><MoreOutlined /></span>
                        </a>
                      </Dropdown>
                    </Col>
                  </Row>}
                  description={
                    <Row>
                      <Col span={24} style={{ textAlign: 'left' }}>
                        {item.highLightText &&
                          <>
                            Has highlighted <span style={{ fontSize: 15, color: "#decb0b", width: '100%' }}> "{item.highLightText}"</span>
                            <br />
                          </>
                        }
                        {item.image && <>
                          <br />
                          <Image
                            width={150}
                            height={150}
                            src={imagePath + item.image}
                          // fallback="data:image/png;base64,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"
                          />
                          <br />
                        </>
                        }
                        {
                          item.document && <>
                            <br />
                            <a href={imagePath + item.document} target='_blank' >
                              <DownloadOutlined /> &nbsp;
                              {item.document}
                            </a>
                            <br />
                          </>
                        }
                        <div style={{ paddingTop: 20 }}>
                          <span style={{ fontSize: 15, color: "#000", width: '100%' }}>{item.commentText}</span>
                        </div>
                      </Col>
                    </Row>
                  }
                />
              </List.Item>
            </div>
            {/* Reply start */}
            <div style={{ padding: 0, marginBottom: 10, border: '1px solid #dfe0eb' }}>
              {/* {item.commentReply && item.commentReply.length > 0 && */}
              <>
                <List.Item style={{ padding: 0, borderBottom: 0 }}>
                  <List
                    style={{ width: '100%', height: '100%', overflow: 'auto' }}
                    itemLayout="horizontal"
                    dataSource={item.commentReply}
                    locale={{ emptyText: <p>No replies</p> }}
                    renderItem={(ritem: any) => (
                      <>
                        <div style={{ marginTop: 0, marginBottom: 0, padding: '5px 10px 0px 30px' }}>
                          <List.Item >
                            <List.Item.Meta
                              style={{ textAlign: 'left' }}
                              //avatar={<Avatar className={'avtar-img'} src="./images/doc-user-image.png" />}
                              //avatar={<Avatar className={'avtar-img'} icon={<UserOutlined />} />}
                              avatar={ritem.replyUserDetail.profilePic ? <Avatar className={'avtar-img'} src={profileImagePath + ritem.replyUserDetail.profilePic} /> : <Avatar className={'avtar-img'} icon={<UserOutlined />} />}
                              title={<Row>
                                <Col span={20} style={{ textAlign: 'left' }}>
                                  <span style={{ fontSize: 18, fontWeight: 500 }}>{ritem.sendByUser}</span>
                                  <br />
                                  <span style={{ color: '#9B9B9B' }}>{ritem.senderUserType}</span>
                                </Col>
                                <Col span={4} style={{ textAlign: 'right' }}>
                                  <Dropdown
                                    overlay={() => completedmenu("reply", ritem)}
                                    trigger={["click"]}
                                    placement="bottomRight"
                                    arrow
                                  >
                                    <a
                                      style={{ color: "#c5c7cd", fontSize: 25 }}
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      <span style={{ fontSize: 16, fontWeight: 500 }}><MoreOutlined /></span>
                                    </a>
                                  </Dropdown>
                                </Col>
                              </Row>}
                              description={
                                <Row>
                                  <Col span={24} style={{ textAlign: 'left' }}>
                                    {/* {ritem.image &&
                                      <Image
                                        width={150}
                                        height={150}
                                        src="error"
                                        fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                                      />
                                    } */}

                                    {ritem.image && <>
                                      <br />
                                      <Image
                                        width={150}
                                        height={150}
                                        src={imagePath + ritem.image}
                                      // fallback="data:image/png;base64,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"
                                      />
                                      <br />
                                    </>
                                    }
                                    {
                                      ritem.document && <>
                                        <br />
                                        <a href={imagePath + ritem.document} target='_blank' >
                                          <DownloadOutlined /> &nbsp;
                                          {ritem.document}
                                        </a>
                                        <br />
                                      </>
                                    }
                                    <div style={{ paddingTop: 20 }}>
                                      <span style={{ fontSize: 15, color: "#000", width: '100%' }}>{ritem.commentText}</span>
                                    </div>
                                  </Col>
                                </Row>
                              }
                            />
                          </List.Item>
                        </div>
                      </>
                    )}
                  />
                </List.Item>

                <MentionsInput
                  className={'uper-comment-input'}
                  placeholder="Add a reply"
                  // markup="@[__display__](__id__)"
                  value={RplyTypeInputData}
                  onChange={handleRplyAtRateCommentChange}
                  singleLine="true"
                >
                  <Mention appendSpaceOnAdd="true" trigger="@" data={AtRateUsers} />
                </MentionsInput>
                <Upload showUploadList={false} accept=".jpg,.png,.jpeg,.pdf" onChange={addAttachments}>
                  <IoMdAttach style={{
                    position: 'relative',
                    bottom: '43px',
                    left: '143px',
                    fontSize: 21, marginTop: 2, cursor: 'pointer', color: 'rgba(0,0,0,.45)'
                  }} /></Upload>
                <img src="./flaticons/send.png"
                  onClick={(e) => addCommentReply(e, item.uuid)}
                  style={{
                    position: 'relative',
                    bottom: '49px',
                    left: '143px', width: '20px', height: '21px', cursor: 'pointer'
                  }} />


                {/* <Input
                  className={'replyinputclass'}
                  style={{ width: '90%', background: '#F2F2F2', marginTop: 10, marginBottom: 10, marginLeft: 10, marginRight: 10, border: '1px solid #dfe0eb', borderTopColor: '#dfe0eb', borderRadius: 32 }}
                  placeholder="Add a reply"
                  // onChange={(e) => setReplyText(e.target.value)}
                  onChange={(e) => {
                    //setReplyText(e.target.value);
                    let name = 'reply_' + item.uuid;
                    setReplyText(prev => ({
                      ...prev,
                      [name]: e.target.value
                    }));
                  }}
                  onPressEnter={(e) => addCommentReply(e, item.uuid)}
                  value={replyText['reply_' + item.uuid]}
                  suffix={
                    <Upload showUploadList={false} accept=".jpg,.png,.jpeg,.pdf" onChange={addAttachments}>
                      <IoMdAttach style={{ fontSize: 20, marginTop: 2, cursor: 'pointer', color: 'rgba(0,0,0,.45)' }} /></Upload>
                  }
                /> */}
              </>
              {/* // } */}
              {/* reply end */}
            </div>
          </>
        )}
      />
    </>
  );

}